import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import { LimitDiscountManagementContainer } from 'app/containers/Marketing/LimitDiscountManagement'

const LimitDiscountManagementPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.limit_discount_management)}</PageTitle>
      <LimitDiscountManagementContainer />
    </>
  )
}
const LimitDiscountManagementPage = memo(
  LimitDiscountManagementPageCpn,
  isEqual,
)

export default LimitDiscountManagementPage
